import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";

export async function unlockProjeto(projetoId: string): Promise<IResponse<void>> {
    return await axios.put(`/Projetos/Destravar/${projetoId}`);
}
